<template>
  <Skeleton
    v-if="shipmentRequest.loading"
    width="80px"
    height="21px"
    class="bg-gray-darker align-self-center"
  />
  <span v-else-if="!!error" class="text-danger">
    <InfoIcon icon="pi pi-exclamation-triangle" :tooltip="errorMessage" />

    {{
      currentStep === 'rating'
        ? t('routeBuilder.errors.rating')
        : t('errors.creatingParam', { param: t('shipments.shipments') })
    }}
  </span>
  <span v-else-if="!rateQuote" class="text-warning">
    <InfoIcon
      icon="pi pi-exclamation-triangle"
      :tooltip="t('routeBuilder.noRateQuoteWarning')"
      :tooltip-disabled="!!shipmentRequest.data?.result?.shipmentId"
    />

    {{ t('common.noParam', { param: t('rateShop.rateQuotes') }) }}
  </span>
  <span
    v-else
    class="font-medium"
    :class="{
      'text-success': !hasError,
      'text-danger': hasError,
    }"
  >
    {{
      renderMoney(rateQuote.totalPrice, {
        currencyCode: rateQuote.currencyCode,
      })
    }}
  </span>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { renderMoney } from '@rygen/rygen-ui/i18n';

import { RouteBuilderPhase2Step } from '@/model/routeBuilder/phase2';

import { DataTableRow } from '@/components/routeBuilder/rateShop/RouteBuilderPhase2RateShopTable.vue';
import InfoIcon from '@rygen/rygen-ui/components/ui/InfoIcon.vue';
import Skeleton from 'primevue/skeleton';

const props = defineProps({
  shipmentRequest: {
    type: Object as PropType<DataTableRow['data']>,
    default: () => ({ loading: false }),
  },
  currentStep: {
    type: String as PropType<RouteBuilderPhase2Step>,
    default: () => 'rating',
  },
});
const { shipmentRequest, currentStep } = toRefs(props);

const { t } = useI18n();

const hasError = computed(() => !!shipmentRequest.value.error);

const rateQuote = computed(() => {
  return shipmentRequest.value.data?.rateQuote;
});

const error = computed(() => shipmentRequest.value.error);
const errorMessage = computed(() => {
  return shipmentRequest.value.error?.response?.data?.exceptionMessage ?? '';
});
</script>
